export const RouterRegister = [
  {
    path: "/register", // 注册 验证码
    name: "注册",
    component: (resolve) => require(/* webpackChunkName: "register" */ ["@/views/register/Code"], resolve),
  },
  {
    path: "/register/password", // 注册 密码
    name: "注册",
    component: (resolve) => require(/* webpackChunkName: "register" */ ["@/views/register/Password"], resolve),
  },
];
